<template>
  <div class="scorePrepared">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>标准得分</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/备注"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">
          新建
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:memo|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'scorePrepared',
                title: '标准得分'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <c-table :fields="extFields">
            <template slot="filterDate">
              <el-table-column label="时间范围" width="300">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div
                      v-html="osg.toBreak(formatFilterDate(scope.row.filterDate), '、')"
                      slot="content"
                    ></div>
                    <div class="oneLine">
                      {{ formatFilterDate(scope.row.filterDate) }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <!-- 1、禁用状态的标准得分数据按钮仅支持：编辑、启用、运算标准得分。 2、启用状态的标准得分数据按钮仅支持：复制。 -->
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.state == 0" @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.state == 1" @click.native="doEdit(scope.row)">
                    查看
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.state == 1" @click.native="doCopy(scope.row)">
                    复制
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.state == 0" @click.native="doEnable(scope.row)">
                    启用
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row)"
                  >
                    禁用
                  </el-dropdown-item> -->
                  <!-- <el-dropdown-item @click.native="doRemove(scope.row)">
                    删除
                  </el-dropdown-item> -->
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doComputing(scope.row._id)"
                  >
                    运算标准得分
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doSupplement(scope.row._id)">
                    增补标准得分
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="标准得分"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="100%"
      height="100%"
      class="scoreList-dialog"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="110px"
        :disabled="formData.state == 1 ? true : false"
      >
        <template slot="filterDate">
          <div v-for="(item, i) in formData.filterDate" :key="i" class="c-flex">
            <el-date-picker
              v-model="item.datetimerange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="c-m-b-10"
            ></el-date-picker>
            <div
              class="datetimerange-remove"
              v-if="formData.filterDate.length != 1 && formData.state != 1"
            >
              <i class="el-icon-remove" @click="removeFilterDate(i)"></i>
            </div>
          </div>
          <el-button plain size="small" icon="el-icon-plus" @click="addFilterDate">
            添加时间范围
          </el-button>
        </template>
        <template slot="scoreList">
          <el-table
            ref="scoreListTable"
            :data="formData.scoreList"
            highlight-current-row
            border
            height="calc(80vh - 130px)"
            class="c-table-border scoreList-table"
          >
            <el-table-column
              label="资源名称"
              prop="srName"
              width="100"
              show-overflow-tooltip
              fixed
            ></el-table-column>
            <el-table-column label="操作" prop="srName" width="78" show-overflow-tooltip fixed>
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.editable"
                  type="primary"
                  size="mini"
                  @click="rowEdit(scope.row, scope.$index)"
                >
                  编辑
                </el-button>
                <el-button
                  v-else
                  type="success"
                  size="mini"
                  @click="rowSave(scope.row, scope.$index)"
                >
                  保存
                </el-button>
              </template>
            </el-table-column>
            <template v-for="(item, i) in options.scoreCalcRule">
              <el-table-column :label="item.name" :key="i">
                <el-table-column label="指标值" :prop="item._id + '_IndexVal'"></el-table-column>
                <el-table-column
                  label="得分值"
                  :prop="item._id + '_ScoreVal'"
                  sortable
                  width="90px"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      v-if="scope.row.editable"
                      :controls="false"
                      v-model="scope.row[item._id + '_ScoreVal']"
                      :precision="2"
                      :min="0"
                      placeholder="请输入指标值"
                    ></el-input-number>
                    <span v-else>
                      {{ scope.row[item._id + '_ScoreVal'] }}
                      <!-- 右上角展示当前值与初始值的差值 -->
                      <el-tooltip
                        v-if="
                          scope.row.original &&
                            scope.row.original[item._id + '_ScoreVal'] !=
                              scope.row[item._id + '_ScoreVal']
                        "
                        class="item"
                        effect="dark"
                        placement="top-start"
                      >
                        <div
                          slot="content"
                          v-if="
                            scope.row[item._id + '_ScoreVal'] -
                              scope.row.original[item._id + '_ScoreVal'] >
                              0
                          "
                        >
                          此单元格展示的是当前分值，比初始分值增加了{{
                            osg.amountFilter(
                              scope.row[item._id + '_ScoreVal'] -
                                scope.row.original[item._id + '_ScoreVal']
                            )
                          }}分
                        </div>
                        <div slot="content" class="c_red" v-else>
                          此单元格展示的是当前分值，比初始分值减少了{{
                            osg.amountFilter(
                              Math.abs(
                                scope.row[item._id + '_ScoreVal'] -
                                  scope.row.original[item._id + '_ScoreVal']
                              )
                            )
                          }}分
                        </div>
                        <span
                          class="diff"
                          :class="
                            scope.row[item._id + '_ScoreVal'] -
                              scope.row.original[item._id + '_ScoreVal'] >
                            0
                              ? 'c_blue'
                              : 'c_red'
                          "
                        >
                          {{
                            osg.amountFilter(
                              scope.row[item._id + '_ScoreVal'] -
                                scope.row.original[item._id + '_ScoreVal']
                            )
                          }}
                        </span>
                      </el-tooltip>
                    </span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="权重" :prop="item._id + '_Weight'"></el-table-column> -->
              </el-table-column>
            </template>
          </el-table>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave" v-if="formData.state != 1">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      name: 'scorePrepared',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        scoreCalcRule: [] // 指标得分规则
      },
      area: {
        options: this.osg.areaList
      }
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('scorePrepared', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: {},
        filterDate: [
          {
            datetimerange: null,
            startDate: '',
            endDate: ''
          }
        ],
        scoreList: []
      };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/scorePrepared/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      // 处理多段时间范围
      row.filterDate.map(item => {
        if (this.$util.isJson(item.datetimerange)) {
          item.datetimerange = JSON.parse(item.datetimerange);
        }
      });
      // 保存初始得分明细
      row.scoreList.map(item => {
        if (!item.original) {
          item.original = this.$util.deepCopy(item);
        }
        item.editable = false;
      });
      this.formData = row;
      this.getScoreCalcRule(); // 查询该行政区划的指标得分规则
      this.openDetail = true;
    },
    // 复制
    doCopy(row) {
      row = this.$util.deepCopy(row);
      row.name += '的副本';
      row.state = 0; // 复制时默认传0
      delete row._id;
      delete row.createTime;
      delete row.createUser;
      delete row.createUserName;
      delete row.updateTime;
      delete row.updateUser;
      delete row.updateUserName;
      this.osg.ajax('biz/scorePrepared/upsert.do', { data: JSON.stringify(row) }, () => {
        this.getData();
        this.osg.toast('复制成功！');
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        let params = this.$util.deepCopy(this.formData);
        let filterDate = [];
        // 处理多段时间范围
        params.filterDate.map(item => {
          if (item.datetimerange) {
            item.startDate = item.datetimerange[0];
            item.endDate = item.datetimerange[1];
            item.datetimerange = JSON.stringify(item.datetimerange);
            filterDate.push(item);
          }
        });
        params.filterDate = filterDate;
        if (params.filterDate.length == 0) {
          this.osg.toast('请至少选择1段时间范围', 'warning');
          return;
        }
        this.osg.ajax('biz/scorePrepared/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(row) {
      this.osg.confirm(`是否确认启用“${row.name}”？`, () => {
        this.osg.ajax('biz/scorePrepared/enable.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doDisable(row) {
      this.osg.confirm(`是否确认禁用“${row.name}”？`, () => {
        this.osg.ajax('biz/scorePrepared/disable.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除“${row.name}”？`, () => {
        this.osg.ajax('biz/scorePrepared/delete.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功');
        });
      });
    },
    doComputing(id) {
      this.osg.confirm('是否确认运算标准得分？', () => {
        this.osg.ajax('biz/scorePrepared/computing.do', { id }, () => {
          this.getData();
          this.osg.toast('后台正在生成中，请稍等10秒后刷新页面查看！');
        });
      });
    },
    doSupplement(id) {
      this.osg.confirm('是否确认增补标准得分？', () => {
        this.osg.ajax('biz/scorePrepared/supplement.do', { id }, () => {
          this.getData();
          this.osg.toast('后台正在生成中，请稍等10秒后刷新页面查看！');
        });
      });
    },
    getScoreCalcRule() {
      this.osg.ajax(
        'biz/scoreCalcRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:regions|array#and': this.formData.region,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.$set(this.options, 'scoreCalcRule', res.data);
          this.$nextTick(() => {
            this.$refs.scoreListTable.doLayout();
            this.$forceUpdate();
          });
        }
      );
    },
    rowEdit(row, index) {
      this.formData.scoreList.map((item, i) => {
        this.$set(this.formData.scoreList[i], 'editable', false);
      });
      this.$set(this.formData.scoreList[index], 'editable', true);
    },
    rowSave(row, index) {
      this.$set(this.formData.scoreList[index], 'editable', false);
    },
    addFilterDate() {
      this.formData.filterDate.push({
        datetimerange: null,
        startDate: '',
        endDate: ''
      });
    },
    removeFilterDate(index) {
      this.formData.filterDate.splice(index, 1);
    },
    formatFilterDate(filterDate) {
      let str = '';
      filterDate.map(item => {
        str += item.startDate + ' 至 ' + item.endDate + '、';
      });
      return str.substring(0, str.length - 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.scorePrepared {
  .datetimerange-remove {
    width: 20px;
    text-align: center;
    color: #f2795b;
    font-size: 18px;
    margin-left: 10px;
    .el-icon-remove {
      cursor: pointer;
    }
  }
  .scoreList-dialog {
    ::v-deep .el-dialog__body {
      padding: 20px 30px 0 !important;
    }
    .scoreList-table {
      .el-input-number {
        width: 100%;
        ::v-deep .el-input__inner {
          padding: 0;
          text-align: center !important;
        }
      }
      .diff {
        font-weight: 600;
        position: absolute;
        top: 0;
        right: 3px;
      }
    }
  }
}
</style>
